module.exports = "/_next/static/images/ourPartnersComcastLogo-663020e0c59095e6446cff5f4fcd55ad.webp";